import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FinanceService } from '../shared/finance.service';
import { AngularFireDatabase } from 'angularfire2/database';
import 'rxjs/add/operator/toPromise';
import {IOption} from 'ng-select';
import { formatDate } from '@telerik/kendo-intl';
import { CommonService } from 'app/common.service';
import { PageChangeEvent } from '@progress/kendo-angular-grid';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { Subject } from 'rxjs';
import { takeUntil, startWith, tap } from 'rxjs/operators';


@Component({
  selector: 'app-finance-transactions',
  templateUrl: './finance-transactions.component.html',
  styleUrls: ['./finance-transactions.component.scss']
})
export class FinanceTransactionsComponent implements OnInit,OnDestroy {
  onDestroy$ = new Subject<void>();
  transactionForm: FormGroup;
  filterForm: FormGroup;
  paymentReceiptForm: FormGroup;
  modalTitle: string;
  FinanceExpenseCatType: Array<IOption> = [];
  OriginalFinanceExpenseCatType: Array<IOption> = [];
  a: any[];
  OriginalCategoryNameList: any[];
  voucherNumber: any;
  TemplateName: string;
  date: any;
  paymentType: any;
  mainBranch: any;
  accounts: any[];
  total: number;
  totalInwords: any;
  constructor(private financeService : FinanceService,private commonService : CommonService, private db : AngularFireDatabase) { }

  ngOnInit() {
    this.initilaizeForm();
    this.getAccountKey();
    this.getAllFinanceExpenseCatType();
    this.getCategoryNameList();
    this.getAllTransactionList();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  lastId = 1900000000;
  bsValue = new Date();
  submitted = false;
  isEdit = false;
  id:any;
  from:any;
  name:any;
  to:any;
  dbName:any;
  columnName:any;
  TransactionsList:any;
  originalTransactionsList:any;
  list = [];
  CategoryNameList = [];
  CategoryNameListFilter : Array<IOption> = [];
  transactionTypeList : Array<IOption> = [
    { label: 'Payment', value: 'Payment' },
    { label: 'Receipt', value: 'Receipt' },
    { label: 'Journal', value: 'Journal' }
  ];
  paymentTypeList : Array<IOption> = [
    { label: 'Cash', value: 'Cash' },
    { label: 'Cheque', value: 'Cheque' }
  ];
  secondvalue:string;
  today=new Date();
  categoryName:any;
  public skip = 0;
  public pageSize = 10;
  options: FormlyFormOptions = {};
  myForm : FormGroup;
  model = {
    Accounts: [{}],
  };
  selfthis =this;
  paymentReceiptFields: FormlyFieldConfig[] = [
    {
      key: 'Accounts',
      type: 'repeat',
      fieldArray: {
        fieldGroupClassName: 'row',
        templateOptions: {
          btnText: 'Add another Row',
        },
        fieldGroup: [
          {
            className: 'col-md-6',
            type: 'select',
            key: 'AccountName',
            defaultValue:'',
            templateOptions: {
              key: 'AccountName',
              label: 'Account Name',
              required: true,
              options: this.CategoryNameList
            },
          },
          {
            type: 'input',
            key: 'Amount',
            className: 'col-md-6',
            templateOptions: {
              type: 'number',
              label: 'Amount',
              required: true,
              min:1,
              max:9999999
            },
            lifecycle: {
              onInit: (form, field) => {
                console.log(this);
                // const teams = [
                //   { id: '1', name: 'Bayern Munich', sportId: '1' },
                //   { id: '2', name: 'Real Madrid', sportId: '1' },
                //   { id: '3', name: 'Cleveland', sportId: '2' },
                //   { id: '4', name: 'Miami', sportId: '2' },
                // ];
      
                form.get('AccountName').valueChanges.pipe(
                  takeUntil(this.onDestroy$),
                  startWith(form.get('AccountName').value),
                  tap(value => {
                    if(this.modalTitle!=='Add Payment Voucher' && value!==null) {
                      field.formControl.setValue('');
                      field.templateOptions.max = parseInt(value.split(',')[2]);
                    }
                  }),
                ).subscribe();
              },
            },
          },
          {
            type: 'input',
            key: 'Remarks',
            className: 'col-md-6',
            templateOptions: {
              type: 'textarea',
              label: 'Remarks',
              required: true
              // addonRight: {
              //   class: 'fa fa-code',
              //   onClick: (to, fieldType, $event) => console.log(to, fieldType, $event),
              // },
            },
          },
        ],
      },
    },
  ];
  @ViewChild('AddTransaction') AddTransactionModal;
  @ViewChild('AddPaymentReceipt') AddPaymentReceiptModal;
  //@ViewChild('AddJournal') AddJournalModal;
  @ViewChild('deleteModal') deleteModal;

  private initilaizeForm() {
    this.transactionForm = new FormGroup({
      transactionType: new FormControl('',Validators.required),
      ledgerType:new FormControl('')
      // categoryName: new FormControl('',Validators.required),
      // date: new FormControl('',Validators.required),
      // description: new FormControl('',Validators.required),
      // amount: new FormControl('',[Validators.required,Validators.pattern('-?[0-9]*[\.]?[0-9]{1,2}')]),
      // id:new FormControl(),
      // dateTimestamp:new FormControl('')
    });
    this.filterForm = new FormGroup({
      categoryName: new FormControl(),
      fromDate: new FormControl(),
      toDate: new FormControl(),
    });

    this.paymentReceiptForm = new FormGroup({
      id: new FormControl('',Validators.required),
      date: new FormControl('',Validators.required),
      paymentType: new FormControl('',Validators.required),
      branchAccount: new FormControl('',Validators.required),
      type: new FormControl('')
    });

    this.myForm = new FormGroup({});


  }

  getAccountKey() {
    const d = this.db.list('/financeTransactions', ref => ref.orderByKey().limitToLast(1)).valueChanges();
    d.subscribe(data => {
      data.forEach(d => {
        var year = (String(d["id"])).substring(0, 2);
        var date = new Date();
        var currentYear = date.getFullYear();
        if (year == (String(currentYear)).substring(2,4)) {
          this.lastId = parseInt(d["id"]) + 1;
        } else {
          this.lastId = parseInt((String(currentYear)).substring(2,4) + "00000000");
        }
      });
      //this.initilaizeForm();
    });
  }

  checkProfitLoss(value,column,db) {
    let promise = new Promise((resolve, reject) => {
      return this.financeService.find(value,column,db).once("value").then(res => { // Success
       resolve([res.node_.children_.root_.key,res.val()]);
       });
     });
     return promise;
  }

  filter(from,to,dbName,columnName,categoryName) {
    var self = this;
    let promise = new Promise((resolve, reject) => {
      return this.financeService.filter(from,to,dbName,columnName).then(res => { 
        self.TransactionsList = [];
        self.originalTransactionsList = [];
        res.forEach(function (childSnap) {
          if(categoryName=="" || categoryName=="All") {
            self.TransactionsList.push({
              "CategoryName": String(childSnap.val().categoryName),
              "Date": String(childSnap.val().date),
              "Description": String(childSnap.val().description),
              "Amount": String(childSnap.val().amount),
              "id": childSnap.ref.getKey()
            });

            self.originalTransactionsList.push({
              "CategoryName": String(childSnap.val().categoryName),
              "Date": String(childSnap.val().date),
              "Description": String(childSnap.val().description),
              "Amount": String(childSnap.val().amount),
              "id": childSnap.ref.getKey()
            });
          } else if(categoryName==String(childSnap.val().categoryName)) {  
            self.TransactionsList.push({
              "CategoryName": String(childSnap.val().categoryName),
              "Date": String(childSnap.val().date),
              "Description": String(childSnap.val().description),
              "Amount": String(childSnap.val().amount),
              "id": childSnap.ref.getKey()
            });

            self.originalTransactionsList.push({
              "CategoryName": String(childSnap.val().categoryName),
              "Date": String(childSnap.val().date),
              "Description": String(childSnap.val().description),
              "Amount": String(childSnap.val().amount),
              "id": childSnap.ref.getKey()
            });
          }
        });
        self.loadItemSearchResult();
        resolve(self.TransactionsList);
       });
     });
     return promise;
  }

  getAllFinanceExpenseCatType() {
    var y :any;
    var x = this.financeService.getAllFinanceExpenseCatType();
    x.snapshotChanges().subscribe(item => {
      this.FinanceExpenseCatType = [];
      this.OriginalFinanceExpenseCatType = [];
      item.forEach(element => {
        y = element.payload.toJSON();
        this.FinanceExpenseCatType.push({label:y.typeName,value:y.typeName});

        this.OriginalFinanceExpenseCatType.push({label:y.typeName,value:y.typeName});
      });
    });
  }
  
  getCategoryNameList() {
    var y :any;
    var catType = this.db.list("financeExpenseCat");
    catType.snapshotChanges().subscribe(item=>{
    this.CategoryNameList = [];
    this.OriginalCategoryNameList = [];
    this.CategoryNameListFilter = [];
    item.forEach(element =>{
       y = element.payload.toJSON();
      //  var result = Object.keys(y).map(function(key) {
      //   return [Number(key), y[key]];
      // });
      var result = [];
      //result.push({"categoryName":y.categoryName,"categoryType":y.categoryType,"amount":y.amount,"id":element.key})
        this.CategoryNameList.push({label:String(y.categoryName),value:y.categoryName+','+y.categoryType+','+y.amount+','+element.key});
        this.OriginalCategoryNameList.push({label:String(y.categoryName),value:y.categoryName+','+y.categoryType+','+y.amount+','+element.key});
        this.CategoryNameListFilter.push({label:String(y.categoryName),value:String(y.categoryName)});
        this.financeService.CategoryNamePicklist = this.CategoryNameList;
        //this.paymentReceiptFields['0'].fieldGroup['0'].fieldGroup['0'].templateOptions.options = this.CategoryNameList;
    });
    this.CategoryNameListFilter.unshift({label:"All",value:"All"});
    //console.log("filter==> "+this.CategoryNameListFilter[0]);
  });
  }

  getAllTransactionList() {
    var x = this.financeService.getAllTransactionList();
    x.snapshotChanges().subscribe(item=>{
    this.TransactionsList = [];
    this.originalTransactionsList = [];
    item.forEach(element =>{
        this.TransactionsList.push({
          "voucherNumber": String(element.payload.child("voucherNumber").val()),
          "type": String(element.payload.child("type").val()),
          "paymentType": String(element.payload.child("paymentType").val()),
          "date": String(element.payload.child("date").val()),
          "Accounts": element.payload.child("Accounts").val(),
          "branchAccount": String(element.payload.child("branchAccount").val()),
          "id": element.key
        });

        this.originalTransactionsList.push({
          "voucherNumber": String(element.payload.child("voucherNumber").val()),
          "type": String(element.payload.child("type").val()),
          "paymentType": String(element.payload.child("paymentType").val()),
          "date": String(element.payload.child("date").val()),
          "Accounts": element.payload.child("Accounts").val(),
          "branchAccount": String(element.payload.child("branchAccount").val()),
          "id": element.key
        });
    });
    this.loadItemSearchResult();
  });
  }

  onSubmitTransaction() {
    this.submitted = true;
    if (this.transactionForm.valid) {
      if(this.transactionForm.value.ledgerType!==null) {
      this.CategoryNameList = [];
        this.CategoryNameList = this.OriginalCategoryNameList.filter(f => 
          String(f.value.split(',')[1]) === this.transactionForm.value.ledgerType
        );
        this.CategoryNameList.unshift({label:"Select one",value:""});
        this.setDate();
        this.financeService.CategoryNamePicklist = this.CategoryNameList;
      }
      if(this.transactionForm.value.transactionType==='Payment') {
        this.submitted = false;
        this.modalTitle = 'Add Payment Voucher';
        this.AddPaymentReceiptModal.show();
        this.paymentReceiptForm.controls['type'].setValue('Payment');
        this.transactionForm.reset();
        this.AddTransactionModal.hide();
      } else if(this.transactionForm.value.transactionType==='Receipt') {
        this.submitted = false;
        this.modalTitle = 'Add Receipt Voucher';
        this.AddPaymentReceiptModal.show();
        this.paymentReceiptForm.controls['type'].setValue('Receipt');
        this.transactionForm.reset();
        this.AddTransactionModal.hide();
      } else if(this.transactionForm.value.transactionType==='Journal') {
        //this.AddJournalModal.show();
      }
    //   this.transactionForm.value.dateTimestamp = formatDate(this.transactionForm.value.date, 'yyyy/MM/dd');
    //   this.transactionForm.value.date = formatDate(this.transactionForm.value.date, 'dd/MM/yyyy');
    //   this.checkProfitLoss(this.transactionForm.value.categoryName, 'categoryName', 'financeExpenseCat').then((data) => {
    //     if (data) {
    //       var key = data[0];
    //       var returnedValue = data[1];
    //       this.secondvalue = returnedValue[key].categoryType;
    //       this.checkProfitLoss(this.secondvalue, 'typeName', 'financeExpenseCatType').then((res) => {
    //         if (res) {
    //           var key = res[0];
    //           var returnedValue = res[1];
    //           this.secondvalue = returnedValue[key].typeProfLoss;
    //           if (this.secondvalue === "Loss" && this.transactionForm.value.amount.indexOf('-')<=-1) {
    //             this.transactionForm.value.amount = '-' + this.transactionForm.value.amount;
    //           }

    //           if (!this.isEdit) {
    //             this.financeService.addFinanceTransaction(this.transactionForm.value).then(() => {
    //               this.submitted = false;
    //               this.transactionForm.reset();
    //               this.AddTransactionModal.hide();
    //             });
    //           }
    //           else {
    //             this.financeService.updateFinanceTransaction(this.transactionForm.value).then(() => {
    //               this.submitted = false;
    //               this.isEdit = false;
    //               this.transactionForm.reset();
    //               this.AddTransactionModal.hide();
    //             });
    //           }
    //         }
    //       });
    //     }
    //   });
     }
  }

  onSubmitVoucher() {
    this.submitted = true;
    var AccountTotalAmount = 0 ;
    if(this.paymentReceiptForm.valid) {
      // console.log("voucher");
      // console.log(this.paymentReceiptForm.value);
      // console.log(this.model);
      if(this.paymentReceiptForm.value.type==="Payment") {
        for(var i=0;i<this.paymentReceiptForm.value.Accounts.length;i++) {
          var AccountParts = this.paymentReceiptForm.value.Accounts[i].AccountName.split(',');
          AccountTotalAmount  = AccountTotalAmount + parseInt(AccountParts[2]);
        }
        if(AccountTotalAmount<=parseInt(this.paymentReceiptForm.value.branchAccount.split(',')[2])) {
          this.paymentReceiptForm.value.date = formatDate(this.paymentReceiptForm.value.date, 'yyyy/MM/dd');
          this.financeService.addFinanceTransaction(this.lastId,this.paymentReceiptForm.value).then(() => {
              this.submitted = false;
              this.reset();
              this.AddPaymentReceiptModal.hide();
        });
        } else {
          //error
        }
      } else {
        this.paymentReceiptForm.value.date = formatDate(this.paymentReceiptForm.value.date, 'yyyy/MM/dd');
        // for(var i=0;i<this.paymentReceiptForm.value.Accounts.length;i++) {
        //   var AccountParts = this.paymentReceiptForm.value.Accounts[i].AccountName.split(',');
        //   AccountTotalAmount  = AccountTotalAmount + parseInt(AccountParts[2]);
        // }
        // if(AccountTotalAmount<=parseInt(this.paymentReceiptForm.value.branchAccount.split(',')[2])) {
          this.financeService.addFinanceTransaction(this.lastId,this.paymentReceiptForm.value).then(() => {
              this.submitted = false;
              this.reset();
              this.AddPaymentReceiptModal.hide();
        });
        // } else {
        //   //error
        // }
      }
    }
  }

  editFinanceTransaction(id) {
    this.isEdit = true;
    this.id = id;
    var x = this.financeService.getFinanceTransaction(id);
    x.once("value").then((FinanceTransaction)=>{
      this.transactionForm.get('categoryName').setValue(FinanceTransaction.child("categoryName").val(),Validators.required);
      this.transactionForm.get('date').setValue(this.commonService.parseDate(FinanceTransaction.child("date").val()),Validators.required);
      this.transactionForm.get('description').setValue(FinanceTransaction.child("description").val(),Validators.required);
      this.transactionForm.get('amount').setValue(FinanceTransaction.child("amount").val(),Validators.required);
      this.transactionForm.get('id').setValue(id);
      this.transactionForm.get('dateTimestamp').setValue(this.commonService.parseDate(FinanceTransaction.child("date").val()));
    });
    
    this.AddTransactionModal.show();
  }

  public openDeleteModal(id,name,from):void{
    this.id = id;
    this.from = from;
    this.name = name;
    this.deleteModal.show();
  }
  public delete():void{
    //console.log("from",this.from,this.id);
    switch(this.from)
    {
      case 'Transaction':
      this.financeService.deleteFinanceTransaction(this.id).then(()=>{
        this.id = null;
        this.from = null;
        this.deleteModal.hide();
      });
      break;
    }
  }

  //Filters

  onSubmitFilter() {
    this.from = formatDate(this.filterForm.value.fromDate, 'yyyy/MM/dd');
    if(this.from=="") {
      this.from = "1970/01/01";
    }
    this.to = formatDate(this.filterForm.value.toDate, 'yyyy/MM/dd');
    if(this.to=="") {
      this.to = formatDate(this.today, "yyyy/MM/dd");
    }
    this.categoryName = this.filterForm.value.categoryName;
    this.dbName = 'financeTransactions';
    this.columnName = 'dateTimestamp';
    this.filter(this.from,this.to,this.dbName,this.columnName,this.categoryName).then((res)=> {
      //console.log(res);
      //this.loadItemSearchResult();
    });
  }

  onClearFilter() {
    this.filterForm.get('fromDate').setValue("");
    this.filterForm.get('toDate').setValue("");
    this.filterForm.get('categoryName').setValue("");
    this.getAllTransactionList();
  }

  loadItemSearchResult() {
    this.TransactionsList = {
      data: this.originalTransactionsList.slice(this.skip, this.skip + this.pageSize),
      total: this.originalTransactionsList.length
    };

  }
  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.loadItemSearchResult();
  }

  reset() {
    this.options.resetModel();
    this.initilaizeForm();
  }

  setDate() {
    //this.getAccountKey();
    this.paymentReceiptForm.controls['id'].setValue(this.lastId);
    this.paymentReceiptForm.controls['date'].setValue(new Date());
    //this.paymentReceiptFields['0'].fieldGroup.filter(f => 
      //f.fieldGroup['0']
    //).templateOptions.options = this.CategoryNameList;
    this.paymentReceiptFields['0'].fieldGroup['0'].fieldGroup['0'].templateOptions.options = this.CategoryNameList;
  //this.paymentReceiptFields['0'].fieldGroup['0'].fieldGroup['0'].defaultValue = this.CategoryNameList[0].value;
  }

  myModelChanged(val){
    console.log(val);
  }

  print(transaction) {
    this.voucherNumber = transaction.id;
    if(transaction.type==='Payment') {
      this.TemplateName = 'Payment';
    } else if(transaction.type==='Receipt') {
      this.TemplateName = 'Receipt';
    } else {
      this.TemplateName = 'Journal';
    }
    this.date = transaction.date;
    this.paymentType = transaction.paymentType;
    this.mainBranch = transaction.branchAccount.split(',')[0];
    this.accounts = transaction.Accounts;
    this.total =0;
    for(var i=0;i<this.accounts.length;i++) {
      this.total=this.total+ this.accounts[i].Amount;
    }
    this.totalInwords = this.inWords(this.total);
    let printContents, popupWin;
    setTimeout(function(){
    printContents = document.getElementById('print-section');
    popupWin = window.open('', '_blank', 'width=600,height=600,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    popupWin.document.open();
    popupWin.document.write('<html><head><title></title><style> html {  font-family: sans-serif;  line-height: 1.15;  -webkit-text-size-adjust: 100%;  -ms-text-size-adjust: 100%;  -ms-overflow-style: scrollbar;  -webkit-tap-highlight-color: transparent;}.container-fluid {  padding-right: 90px;  padding-left: 230px;  }.row {  display: -webkit-box;  display: -ms-flexbox;  display: flex;  -ms-flex-wrap: wrap;  flex-wrap: wrap;  margin-right: -15px;  margin-left: -15px;}@page {    size: a3;  }@media (min-width: 576px) {   .col-sm {    -ms-flex-preferred-size: 0;    flex-basis: 0;    -webkit-box-flex: 1;    -ms-flex-positive: 1;    flex-grow: 1;    max-width: 100%;  }  .col-sm-auto {    -webkit-box-flex: 0;    -ms-flex: 0 0 auto;    flex: 0 0 auto;    width: auto;    max-width: none;  }  .col-sm-1 {    -webkit-box-flex: 0;    -ms-flex: 0 0 8.333333%;    flex: 0 0 8.333333%;    max-width: 8.333333%;  }  .col-sm-2 {    -webkit-box-flex: 0;    -ms-flex: 0 0 16.666667%;    flex: 0 0 16.666667%;    max-width: 16.666667%;  }  .col-sm-3 {    -webkit-box-flex: 0;    -ms-flex: 0 0 25%;    flex: 0 0 25%;    max-width: 25%;  }  .col-sm-4 {    -webkit-box-flex: 0;    -ms-flex: 0 0 33.333333%;    flex: 0 0 33.333333%;    max-width: 33.333333%;  }  .col-sm-5 {    -webkit-box-flex: 0;    -ms-flex: 0 0 41.666667%;    flex: 0 0 41.666667%;    max-width: 41.666667%;  }  .col-sm-6 {    -webkit-box-flex: 0;    -ms-flex: 0 0 50%;    flex: 0 0 50%;    max-width: 50%;  }  .col-sm-7 {    -webkit-box-flex: 0;    -ms-flex: 0 0 58.333333%;    flex: 0 0 58.333333%;    max-width: 58.333333%;  }  .col-sm-8 {    -webkit-box-flex: 0;    -ms-flex: 0 0 66.666667%;    flex: 0 0 66.666667%;    max-width: 66.666667%;  }  .col-sm-9 {    -webkit-box-flex: 0;    -ms-flex: 0 0 75%;    flex: 0 0 75%;    max-width: 75%;  }  .col-sm-10 {    -webkit-box-flex: 0;    -ms-flex: 0 0 83.333333%;    flex: 0 0 83.333333%;    max-width: 83.333333%;  }  .col-sm-11 {    -webkit-box-flex: 0;    -ms-flex: 0 0 91.666667%;    flex: 0 0 91.666667%;    max-width: 91.666667%;  }  .col-sm-12 {    -webkit-box-flex: 0;    -ms-flex: 0 0 100%;    flex: 0 0 100%;    max-width: 100%;  }  .order-sm-first {    -webkit-box-ordinal-group: 0;    -ms-flex-order: -1;    order: -1;  }  .order-sm-last {    -webkit-box-ordinal-group: 14;    -ms-flex-order: 13;    order: 13;  }  .order-sm-0 {    -webkit-box-ordinal-group: 1;    -ms-flex-order: 0;    order: 0;  }  .order-sm-1 {    -webkit-box-ordinal-group: 2;    -ms-flex-order: 1;    order: 1;  }  .order-sm-2 {    -webkit-box-ordinal-group: 3;    -ms-flex-order: 2;    order: 2;  }  .order-sm-3 {    -webkit-box-ordinal-group: 4;    -ms-flex-order: 3;    order: 3;  }  .order-sm-4 {    -webkit-box-ordinal-group: 5;    -ms-flex-order: 4;    order: 4;  }  .order-sm-5 {    -webkit-box-ordinal-group: 6;    -ms-flex-order: 5;    order: 5;  }  .order-sm-6 {    -webkit-box-ordinal-group: 7;    -ms-flex-order: 6;    order: 6;  }  .order-sm-7 {    -webkit-box-ordinal-group: 8;    -ms-flex-order: 7;    order: 7;  }  .order-sm-8 {    -webkit-box-ordinal-group: 9;    -ms-flex-order: 8;    order: 8;  }  .order-sm-9 {    -webkit-box-ordinal-group: 10;    -ms-flex-order: 9;    order: 9;  }  .order-sm-10 {    -webkit-box-ordinal-group: 11;    -ms-flex-order: 10;    order: 10;  }  .order-sm-11 {    -webkit-box-ordinal-group: 12;    -ms-flex-order: 11;    order: 11;  }  .order-sm-12 {    -webkit-box-ordinal-group: 13;    -ms-flex-order: 12;    order: 12;  }  .offset-sm-0 {    margin-left: 0;  }  .offset-sm-1 {    margin-left: 8.333333%;  }  .offset-sm-2 {    margin-left: 16.666667%;  }  .offset-sm-3 {    margin-left: 25%;  }  .offset-sm-4 {    margin-left: 33.333333%;  }  .offset-sm-5 {    margin-left: 41.666667%;  }  .offset-sm-6 {    margin-left: 50%;  }  .offset-sm-7 {    margin-left: 58.333333%;  }  .offset-sm-8 {    margin-left: 66.666667%;  }  .offset-sm-9 {    margin-left: 75%;  }  .offset-sm-10 {    margin-left: 83.333333%;  }  .offset-sm-11 {    margin-left: 91.666667%;  }}@media (min-width: 768px) {  .col-md {    -ms-flex-preferred-size: 0;    flex-basis: 0;    -webkit-box-flex: 1;    -ms-flex-positive: 1;    flex-grow: 1;    max-width: 100%;  }  .col-md-auto {    -webkit-box-flex: 0;    -ms-flex: 0 0 auto;    flex: 0 0 auto;    width: auto;    max-width: none;  }  .col-md-1 {    -webkit-box-flex: 0;    -ms-flex: 0 0 8.333333%;    flex: 0 0 8.333333%;    max-width: 8.333333%;  }  .col-md-2 {    -webkit-box-flex: 0;    -ms-flex: 0 0 16.666667%;    flex: 0 0 16.666667%;    max-width: 16.666667%;  }  .col-md-3 {    -webkit-box-flex: 0;    -ms-flex: 0 0 25%;    flex: 0 0 25%;    max-width: 25%;  }  .col-md-4 {    -webkit-box-flex: 0;    -ms-flex: 0 0 33.333333%;    flex: 0 0 33.333333%;    max-width: 33.333333%;  }  .col-md-5 {    -webkit-box-flex: 0;    -ms-flex: 0 0 41.666667%;    flex: 0 0 41.666667%;    max-width: 41.666667%;  }  .col-md-6 {    -webkit-box-flex: 0;    -ms-flex: 0 0 50%;    flex: 0 0 50%;    max-width: 50%;  }  .col-md-7 {    -webkit-box-flex: 0;    -ms-flex: 0 0 58.333333%;    flex: 0 0 58.333333%;    max-width: 58.333333%;  }  .col-md-8 {    -webkit-box-flex: 0;    -ms-flex: 0 0 66.666667%;    flex: 0 0 66.666667%;    max-width: 66.666667%;  }  .col-md-9 {    -webkit-box-flex: 0;    -ms-flex: 0 0 75%;    flex: 0 0 75%;    max-width: 75%;  }  .col-md-10 {    -webkit-box-flex: 0;    -ms-flex: 0 0 83.333333%;    flex: 0 0 83.333333%;    max-width: 83.333333%;  }  .col-md-11 {    -webkit-box-flex: 0;    -ms-flex: 0 0 91.666667%;    flex: 0 0 91.666667%;    max-width: 91.666667%;  }  .col-md-12 {    -webkit-box-flex: 0;    -ms-flex: 0 0 100%;    flex: 0 0 100%;    max-width: 100%;  }  .order-md-first {    -webkit-box-ordinal-group: 0;    -ms-flex-order: -1;    order: -1;  }  .order-md-last {    -webkit-box-ordinal-group: 14;    -ms-flex-order: 13;    order: 13;  }  .order-md-0 {    -webkit-box-ordinal-group: 1;    -ms-flex-order: 0;    order: 0;  }  .order-md-1 {    -webkit-box-ordinal-group: 2;    -ms-flex-order: 1;    order: 1;  }  .order-md-2 {    -webkit-box-ordinal-group: 3;    -ms-flex-order: 2;    order: 2;  }  .order-md-3 {    -webkit-box-ordinal-group: 4;    -ms-flex-order: 3;    order: 3;  }  .order-md-4 {    -webkit-box-ordinal-group: 5;    -ms-flex-order: 4;    order: 4;  }  .order-md-5 {    -webkit-box-ordinal-group: 6;    -ms-flex-order: 5;    order: 5;  }  .order-md-6 {    -webkit-box-ordinal-group: 7;    -ms-flex-order: 6;    order: 6;  }  .order-md-7 {    -webkit-box-ordinal-group: 8;    -ms-flex-order: 7;    order: 7;  }  .order-md-8 {    -webkit-box-ordinal-group: 9;    -ms-flex-order: 8;    order: 8;  }  .order-md-9 {    -webkit-box-ordinal-group: 10;    -ms-flex-order: 9;    order: 9;  }  .order-md-10 {    -webkit-box-ordinal-group: 11;    -ms-flex-order: 10;    order: 10;  }  .order-md-11 {    -webkit-box-ordinal-group: 12;    -ms-flex-order: 11;    order: 11;  }  .order-md-12 {    -webkit-box-ordinal-group: 13;    -ms-flex-order: 12;    order: 12;  }  .offset-md-0 {    margin-left: 0;  }  .offset-md-1 {    margin-left: 8.333333%;  }  .offset-md-2 {    margin-left: 16.666667%;  }  .offset-md-3 {    margin-left: 25%;  }  .offset-md-4 {    margin-left: 33.333333%;  }  .offset-md-5 {    margin-left: 41.666667%;  }  .offset-md-6 {    margin-left: 50%;  }  .offset-md-7 {    margin-left: 58.333333%;  }  .offset-md-8 {    margin-left: 66.666667%;  }  .offset-md-9 {    margin-left: 75%;  }  .offset-md-10 {    margin-left: 83.333333%;  }  .offset-md-11 {    margin-left: 91.666667%;  }}@media (min-width: 992px) {  .col-lg {    -ms-flex-preferred-size: 0;    flex-basis: 0;    -webkit-box-flex: 1;    -ms-flex-positive: 1;    flex-grow: 1;    max-width: 100%;  }  .col-lg-auto {    -webkit-box-flex: 0;    -ms-flex: 0 0 auto;    flex: 0 0 auto;    width: auto;    max-width: none;  }  .col-lg-1 {    -webkit-box-flex: 0;    -ms-flex: 0 0 8.333333%;    flex: 0 0 8.333333%;    max-width: 8.333333%;  }  .col-lg-2 {    -webkit-box-flex: 0;    -ms-flex: 0 0 16.666667%;    flex: 0 0 16.666667%;    max-width: 16.666667%;  }  .col-lg-3 {    -webkit-box-flex: 0;    -ms-flex: 0 0 25%;    flex: 0 0 25%;    max-width: 25%;  }  .col-lg-4 {    -webkit-box-flex: 0;    -ms-flex: 0 0 33.333333%;    flex: 0 0 33.333333%;    max-width: 33.333333%;  }  .col-lg-5 {    -webkit-box-flex: 0;    -ms-flex: 0 0 41.666667%;    flex: 0 0 41.666667%;    max-width: 41.666667%;  }  .col-lg-6 {    -webkit-box-flex: 0;    -ms-flex: 0 0 50%;    flex: 0 0 50%;    max-width: 50%;  }  .col-lg-7 {    -webkit-box-flex: 0;    -ms-flex: 0 0 58.333333%;    flex: 0 0 58.333333%;    max-width: 58.333333%;  }  .col-lg-8 {    -webkit-box-flex: 0;    -ms-flex: 0 0 66.666667%;    flex: 0 0 66.666667%;    max-width: 66.666667%;  }  .col-lg-9 {    -webkit-box-flex: 0;    -ms-flex: 0 0 75%;    flex: 0 0 75%;    max-width: 75%;  }  .col-lg-10 {    -webkit-box-flex: 0;    -ms-flex: 0 0 83.333333%;    flex: 0 0 83.333333%;    max-width: 83.333333%;  }  .col-lg-11 {    -webkit-box-flex: 0;    -ms-flex: 0 0 91.666667%;    flex: 0 0 91.666667%;    max-width: 91.666667%;  }  .col-lg-12 {    -webkit-box-flex: 0;    -ms-flex: 0 0 100%;    flex: 0 0 100%;    max-width: 100%;  }  .order-lg-first {    -webkit-box-ordinal-group: 0;    -ms-flex-order: -1;    order: -1;  }  .order-lg-last {    -webkit-box-ordinal-group: 14;    -ms-flex-order: 13;    order: 13;  }  .order-lg-0 {    -webkit-box-ordinal-group: 1;    -ms-flex-order: 0;    order: 0;  }  .order-lg-1 {    -webkit-box-ordinal-group: 2;    -ms-flex-order: 1;    order: 1;  }  .order-lg-2 {    -webkit-box-ordinal-group: 3;    -ms-flex-order: 2;    order: 2;  }  .order-lg-3 {    -webkit-box-ordinal-group: 4;    -ms-flex-order: 3;    order: 3;  }  .order-lg-4 {    -webkit-box-ordinal-group: 5;    -ms-flex-order: 4;    order: 4;  }  .order-lg-5 {    -webkit-box-ordinal-group: 6;    -ms-flex-order: 5;    order: 5;  }  .order-lg-6 {    -webkit-box-ordinal-group: 7;    -ms-flex-order: 6;    order: 6;  }  .order-lg-7 {    -webkit-box-ordinal-group: 8;    -ms-flex-order: 7;    order: 7;  }  .order-lg-8 {    -webkit-box-ordinal-group: 9;    -ms-flex-order: 8;    order: 8;  }  .order-lg-9 {    -webkit-box-ordinal-group: 10;    -ms-flex-order: 9;    order: 9;  }  .order-lg-10 {    -webkit-box-ordinal-group: 11;    -ms-flex-order: 10;    order: 10;  }  .order-lg-11 {    -webkit-box-ordinal-group: 12;    -ms-flex-order: 11;    order: 11;  }  .order-lg-12 {    -webkit-box-ordinal-group: 13;    -ms-flex-order: 12;    order: 12;  }  .offset-lg-0 {    margin-left: 0;  }  .offset-lg-1 {    margin-left: 8.333333%;  }  .offset-lg-2 {    margin-left: 16.666667%;  }  .offset-lg-3 {    margin-left: 25%;  }  .offset-lg-4 {    margin-left: 33.333333%;  }  .offset-lg-5 {    margin-left: 41.666667%;  }  .offset-lg-6 {    margin-left: 50%;  }  .offset-lg-7 {    margin-left: 58.333333%;  }  .offset-lg-8 {    margin-left: 66.666667%;  }  .offset-lg-9 {    margin-left: 75%;  }  .offset-lg-10 {    margin-left: 83.333333%;  }  .offset-lg-11 {    margin-left: 91.666667%;  }}@media (min-width: 1200px) {  .col-xl {    -ms-flex-preferred-size: 0;    flex-basis: 0;    -webkit-box-flex: 1;    -ms-flex-positive: 1;    flex-grow: 1;    max-width: 100%;  }  .col-xl-auto {    -webkit-box-flex: 0;    -ms-flex: 0 0 auto;    flex: 0 0 auto;    width: auto;    max-width: none;  }  .col-xl-1 {    -webkit-box-flex: 0;    -ms-flex: 0 0 8.333333%;    flex: 0 0 8.333333%;    max-width: 8.333333%;  }  .col-xl-2 {    -webkit-box-flex: 0;    -ms-flex: 0 0 16.666667%;    flex: 0 0 16.666667%;    max-width: 16.666667%;  }  .col-xl-3 {    -webkit-box-flex: 0;    -ms-flex: 0 0 25%;    flex: 0 0 25%;    max-width: 25%;  }  .col-xl-4 {    -webkit-box-flex: 0;    -ms-flex: 0 0 33.333333%;    flex: 0 0 33.333333%;    max-width: 33.333333%;  }  .col-xl-5 {    -webkit-box-flex: 0;    -ms-flex: 0 0 41.666667%;    flex: 0 0 41.666667%;    max-width: 41.666667%;  }  .col-xl-6 {    -webkit-box-flex: 0;    -ms-flex: 0 0 50%;    flex: 0 0 50%;    max-width: 50%;  }  .col-xl-7 {    -webkit-box-flex: 0;    -ms-flex: 0 0 58.333333%;    flex: 0 0 58.333333%;    max-width: 58.333333%;  }  .col-xl-8 {    -webkit-box-flex: 0;    -ms-flex: 0 0 66.666667%;    flex: 0 0 66.666667%;    max-width: 66.666667%;  }  .col-xl-9 {    -webkit-box-flex: 0;    -ms-flex: 0 0 75%;    flex: 0 0 75%;    max-width: 75%;  }  .col-xl-10 {    -webkit-box-flex: 0;    -ms-flex: 0 0 83.333333%;    flex: 0 0 83.333333%;    max-width: 83.333333%;  }  .col-xl-11 {    -webkit-box-flex: 0;    -ms-flex: 0 0 91.666667%;    flex: 0 0 91.666667%;    max-width: 91.666667%;  }  .col-xl-12 {    -webkit-box-flex: 0;    -ms-flex: 0 0 100%;    flex: 0 0 100%;    max-width: 100%;  }  .order-xl-first {    -webkit-box-ordinal-group: 0;    -ms-flex-order: -1;    order: -1;  }  .order-xl-last {    -webkit-box-ordinal-group: 14;    -ms-flex-order: 13;    order: 13;  }  .order-xl-0 {    -webkit-box-ordinal-group: 1;    -ms-flex-order: 0;    order: 0;  }  .order-xl-1 {    -webkit-box-ordinal-group: 2;    -ms-flex-order: 1;    order: 1;  }  .order-xl-2 {    -webkit-box-ordinal-group: 3;    -ms-flex-order: 2;    order: 2;  }  .order-xl-3 {    -webkit-box-ordinal-group: 4;    -ms-flex-order: 3;    order: 3;  }  .order-xl-4 {    -webkit-box-ordinal-group: 5;    -ms-flex-order: 4;    order: 4;  }  .order-xl-5 {    -webkit-box-ordinal-group: 6;    -ms-flex-order: 5;    order: 5;  }  .order-xl-6 {    -webkit-box-ordinal-group: 7;    -ms-flex-order: 6;    order: 6;  }  .order-xl-7 {    -webkit-box-ordinal-group: 8;    -ms-flex-order: 7;    order: 7;  }  .order-xl-8 {    -webkit-box-ordinal-group: 9;    -ms-flex-order: 8;    order: 8;  }  .order-xl-9 {    -webkit-box-ordinal-group: 10;    -ms-flex-order: 9;    order: 9;  }  .order-xl-10 {    -webkit-box-ordinal-group: 11;    -ms-flex-order: 10;    order: 10;  }  .order-xl-11 {    -webkit-box-ordinal-group: 12;    -ms-flex-order: 11;    order: 11;  }  .order-xl-12 {    -webkit-box-ordinal-group: 13;    -ms-flex-order: 12;    order: 12;  }  .offset-xl-0 {    margin-left: 0;  }  .offset-xl-1 {    margin-left: 8.333333%;  }  .offset-xl-2 {    margin-left: 16.666667%;  }  .offset-xl-3 {    margin-left: 25%;  }  .offset-xl-4 {    margin-left: 33.333333%;  }  .offset-xl-5 {    margin-left: 41.666667%;  }  .offset-xl-6 {    margin-left: 50%;  }  .offset-xl-7 {    margin-left: 58.333333%;  }  .offset-xl-8 {    margin-left: 66.666667%;  }  .offset-xl-9 {    margin-left: 75%;  }  .offset-xl-10 {    margin-left: 83.333333%;  }  .offset-xl-11 {    margin-left: 91.666667%;  }}body {    min-width: 992px !important;  }body {  margin: 0;  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";  font-size: 1rem;  font-weight: 400;  line-height: 1.5;  color: #212529;  text-align: left;  background-color: #fff;} </style></head><body> '+printContents.innerHTML+'</body></html>');
    popupWin.focus();
    
      popupWin.print();
      popupWin.close();
    },500);
    popupWin.document.close();
  }

  inWords(num) {
    var a = ['','one ','two ','three ','four ', 'five ','six ','seven ','eight ','nine ','ten ','eleven ','twelve ','thirteen ','fourteen ','fifteen ','sixteen ','seventeen ','eighteen ','nineteen '];
    var b = ['', '', 'twenty','thirty','forty','fifty', 'sixty','seventy','eighty','ninety'];
    if ((num = num.toString()).length > 9) return 'overflow';
    num = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!num) return; var str = '';
    str += (num[1] != 0) ? (a[Number(num[1])] || b[num[1][0]] + ' ' + a[num[1][1]]) + 'crore ' : '';
    str += (num[2] != 0) ? (a[Number(num[2])] || b[num[2][0]] + ' ' + a[num[2][1]]) + 'lakh ' : '';
    str += (num[3] != 0) ? (a[Number(num[3])] || b[num[3][0]] + ' ' + a[num[3][1]]) + 'thousand ' : '';
    str += (num[4] != 0) ? (a[Number(num[4])] || b[num[4][0]] + ' ' + a[num[4][1]]) + 'hundred ' : '';
    str += (num[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(num[5])] || b[num[5][0]] + ' ' + a[num[5][1]]) + 'only ' : '';
    return str;
}
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/finance-management/finance-transactions/finance-transactions.component.ts